// icons
import { Icon } from '@iconify/react';

// ----------------------------------------------------------------------
// Migracao MUI -> shadcn/Tailwind: este componente aparece em ~140 arquivos,
// entao a troca precisava ser 100% compativel com o `sx` que cada chamador ja
// manda, sem reintroduzir a armadilha documentada abaixo.

// Poucos nomes de cor do tema MUI ainda aparecem espalhados pelo `sx` dos
// chamadores (ex.: "text.secondary"). Como nao existe mais objeto de tema MUI
// para resolver essas strings, mapeamos os casos realmente usados para o token
// --gps-* equivalente. Qualquer outra string (hex, "red", nome de variavel) e
// repassada como veio - ja e um valor de CSS valido.
const CORES_TEMA_MUI = {
  'text.primary': 'var(--gps-text)',
  'text.secondary': 'var(--gps-muted)',
  'text.disabled': 'var(--gps-faint)',
  'primary.main': 'var(--gps-accent)',
  'error.main': 'var(--gps-danger)',
  'warning.main': 'var(--gps-warn)',
  'info.main': 'var(--gps-info)',
  'success.main': 'var(--gps-ok)',
};

function resolverCor(cor) {
  return CORES_TEMA_MUI[cor] || cor;
}

// MUI trata numero em mr/ml/mt/mb como multiplo de 8px (theme.spacing(1) = 8px).
// Os chamadores deste componente usam so numero (0.5, 1, 2...), entao a mesma
// conta cobre todos os casos vistos no grep.
function comoEspaco(v) {
  return typeof v === 'number' ? v * 8 : v;
}

// Converte o subconjunto de `sx` que os chamadores realmente usam (visto por
// grep em toda a arvore: color, width, height, mr/ml/mt/mb, flexShrink,
// position, transform) em `style` inline. Chave nao reconhecida e ignorada em
// silencio - nunca vaza pro DOM.
function sxParaEstilo(entrada) {
  // sx pode chegar como objeto, array (forma `sx={[base, cond && {...}]}` do
  // MUI) ou falsy. Tratamos os tres para nao regredir nenhum chamador.
  const partes = Array.isArray(entrada) ? entrada : [entrada];
  const estilo = {};
  let teveAlgo = false;

  for (const parte of partes) {
    if (!parte || typeof parte !== 'object') continue;
    teveAlgo = true;
    if (parte.color !== undefined) estilo.color = resolverCor(parte.color);
    if (parte.width !== undefined) estilo.width = parte.width;
    if (parte.height !== undefined) estilo.height = parte.height;
    if (parte.flexShrink !== undefined) estilo.flexShrink = parte.flexShrink;
    if (parte.position !== undefined) estilo.position = parte.position;
    if (parte.transform !== undefined) estilo.transform = parte.transform;
    if (parte.mr !== undefined) estilo.marginRight = comoEspaco(parte.mr);
    if (parte.ml !== undefined) estilo.marginLeft = comoEspaco(parte.ml);
    if (parte.mt !== undefined) estilo.marginTop = comoEspaco(parte.mt);
    if (parte.mb !== undefined) estilo.marginBottom = comoEspaco(parte.mb);
  }

  return teveAlgo ? estilo : undefined;
}

export default function Iconify({ icon, sx = null, ...other }) {
  // `style` e prop nativa do <Icon> do @iconify/react (ele estende
  // SVGProps<SVGSVGElement>), entao dimensiona/colore sem precisar de wrapper.
  // `other` inclui casos como `width`/`height`/`color` passados direto (fora
  // do sx) - o @iconify/react ja aceita esses como props proprias, entao so
  // repassamos, igual o Box antigo fazia via spread.
  const estilo = sxParaEstilo(sx);
  if (estilo) return <Icon icon={icon} style={estilo} {...other} />;
  return <Icon icon={icon} {...other} />;
}
